import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
// 导入字体图标
import './assets/fonts/iconfont.css'
// 导入全局样式表
import './assets/css/global.css'
// 导入全局mixin
import BaseMixin from "@/mixins/base-mixin"
Vue.mixin(BaseMixin)
//全局自定义指令，权限设置
import Dclrights from './plugins/directives.js'
Vue.use(Dclrights)
// 使用vue-lazylocad,图片懒加载
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('../src/assets/img/error.png'),
  loading: require('../src/assets/img/load.gif'),
  attempt: 1
})
//element-ui组件内中英切换
import source from "element-ui/lib/locale/index.js";
import en from "element-ui/lib/locale/lang/en.js";
import zh from "element-ui/lib/locale/lang/zh-CN.js";
Vue.use({locale:store.getters.languageSave == 'zh-CN' ? source.use(zh) : source.use(en)})
//语言中英文切换
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: store.getters.languageSave,    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
      'zh-CN': require('../src/common/lang/zh'),   // 中文语言包
      'en-US': require('../src/common/lang/en')    // 英文语言包
    }
})
//导入全局moment格式化时间
import moment from 'moment'
//统一接口api文件夹里面全部请求函数
import * as API from './api';

Vue.prototype.$http = API
Vue.config.productionTip = false
Vue.filter('fmtdate',function(v){
	return moment(v).format('yyyy-MM-DD HH:mm:ss')
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
